import request from '@/utils/request'

 

export function save_sealproform(data) {
  return request({ url: 'save_sealproform', method: 'post', data: data})
} 